import { useQuery } from "@tanstack/react-query";
import { fetchAffiliateCoupons } from "../utils/affiliateApi";

export const AFFILIATE_COUPONS_QUERY_KEY = ["affiliate", "coupons"];

export const useAffiliateCoupons = ({ start_date = null, end_date = null } = {}) => {
  return useQuery({
    queryKey: [...AFFILIATE_COUPONS_QUERY_KEY, { start_date, end_date }],
    queryFn: () => fetchAffiliateCoupons({ start_date, end_date }),
    refetchOnWindowFocus: false,
  });
};


